import * as React from "react";
import { Carousel, Accordion, List, Modal, Toast } from "antd-mobile";

import styles from "./index.module.css";
import { request } from "../../services";
import { doShare, doChangeTitle } from "../../utils/share";
import { getParam } from "../../utils/getParam";

interface Props {
  baozhi_info: any[];
  curIndex: number;
  baseImg: string;
  baseContent: string;
}

interface State {
  modal1: boolean;
  content: string;
  introtitle: string;
  title: string;
  cid: number;
  share_image: string;
  imgHeight: string;
}

function closest(el: any, selector: any) {
  const matchesSelector =
    el.matches ||
    el.webkitMatchesSelector ||
    el.mozMatchesSelector ||
    el.msMatchesSelector;
  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}

class Index extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      modal1: false,
      content: "",
      introtitle: "",
      title: "",
      cid: 0,
      share_image: "",
      imgHeight: ""
    };
  }

  onClick = (cid: any) => (e: any) => {
    // console.log(cid);
    e.preventDefault(); // 修复 Android 上点击穿透
    this.setState({
      modal1: true
    });
    this.getPaperContent(cid);
  };

  onClose = () => () => {
    this.setState({
      modal1: false
    });
  };

  onWrapTouchStart = (e: any) => {
    // fix touch to scroll background page on iOS
    if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
      return;
    }
    const pNode = closest(e.target, ".am-modal-content");
    if (!pNode) {
      e.preventDefault();
    }
  };

  async getPaperContent(cid: number) {
    const data = { cid };
    const type: number = 2;

    try {
      let res = await request(data, type);
      if (res.code === 1) {
        this.setState((prevState, props) => ({
          content: res.data.content,
          introtitle: res.data.introtitle,
          title: res.data.title,
          cid: res.data.cid,
          share_image: res.data.share_image
        }));
      } else {
        Toast.fail(res.msg, 1);
      }
    } catch (error) {
      throw new Error(error);
    }
  }

  componentDidMount() {}

  afterChange = (index: number) => {
    let curPage = this.props.baozhi_info[index];
    console.log(curPage);
    let data = {
      share_sub_title: doChangeTitle(getParam("type")),
      share_title: curPage.title,
      share_link: `${window.location.href.split("&page")[0]}&page=${index}`
    };
    // console.log(data);
    // doShare(data);
    if (navigator.userAgent.indexOf("MicroMessenger") >= 0) {
      doShare(data);
    } else {
      let fdata = {
        title: curPage.title,
        image: this.props.baseImg,
        content: this.props.baseContent,
        url: `${window.location.href.split("&page")[0]}&page=${index}`
      };
      // console.log(fdata);
      window.share_ini(fdata);
    }
  };

  render() {
    return (
      <div className={styles.Index}>
        {this.props.baozhi_info.length ? (
          <Carousel
            dots={false}
            autoplay={false}
            infinite
            selectedIndex={this.props.curIndex}
            afterChange={index => this.afterChange(index)}
          >
            {this.props.baozhi_info.map(banmian => (
              <div
                key={banmian.banmian_id}
                style={{
                  display: "inline-block",
                  width: "100vw",
                  height: "calc(100vh - 88px)"
                }}
              >
                {banmian.page_list.length ? (
                  <Accordion className="my-accordion">
                    <Accordion.Panel header={banmian.title}>
                      <List className="my-list">
                        {banmian.page_list.map((page: any) => (
                          <List.Item
                            key={page.cid}
                            onClick={this.onClick(page.cid)}
                          >
                            {page.title}
                          </List.Item>
                        ))}
                      </List>
                    </Accordion.Panel>
                  </Accordion>
                ) : (
                  // <div className={styles.banmianTitle}>{banmian.title}</div>
                  <List className="my-list">
                    <List.Item>
                      <div className={styles.banmianTitle}>{banmian.title}</div>
                    </List.Item>
                  </List>
                )}

                <div
                  className={styles.banmian}
                  dangerouslySetInnerHTML={{
                    __html: banmian.imagebg
                  }}
                />
              </div>
            ))}
          </Carousel>
        ) : null}

        <Modal
          visible={this.state.modal1}
          transparent
          maskClosable={false}
          onClose={this.onClose()}
          title={this.state.title}
          footer={[
            {
              text: "关闭",
              onPress: () => {
                // console.log("ok");
                this.onClose()();
              }
            }
          ]}
          wrapProps={{ onTouchStart: this.onWrapTouchStart }}
        >
          <div
            style={{ height: "72vh", overflowY: "scroll", overflowX: "hidden" }}
          >
            <div
              className={styles.content}
              dangerouslySetInnerHTML={{ __html: this.state.content }}
            />
          </div>
        </Modal>
      </div>
    );
  }
}

export default Index;
